import { keycloakService } from 'modules/keycloak';

import AjaxService from './AjaxService';

export const ajaxService = new AjaxService({ keycloakService });
